export const FIXTURES = 'FIXTURES';
export const RESULTS = 'RESULTS';

export enum ProgrammeFilterEnums {
  FIXTURES = 'Fixtures',
  RESULTS = 'Results',
}

export const PROGRAMME_MATCH_TYPE = 'home';
